import apiService from "./apiServices";

export const saveCarrier = async(formData, token) => {
    try {
        const response = await apiService('/carrier/add-carrier', 'POST', formData, null, token);
        return response;
    } catch (errorCaught) {
        // Preserve the error structure from backend
        const error=errorCaught?.response?.data || {};
        if (error?.errors && Array.isArray(error.errors)) {
          throw error;
        }
        throw (error?.message || 'Saving carrier details is failed. Please try again.');
    }
}
  export const updateInsuranceCarrier = async(formData, token) => {
    try {
        const response = await apiService('/carrier/update-carrier', 'PUT', formData, null, token);
        return response;
        } catch (errorCaught) {
           const error=errorCaught?.response?.data || {};
        if (error?.errors && Array.isArray(error.errors)) {
          throw error;
        }
          throw (error?.message || 'Updating carrierdetails is failed. Please try again.');
        }
  }

export const saveCarrierGroup = async (formData, token) => {
  try {
    const response = await apiService('/company-group/', 'POST', formData, null, token);
    return response;
  } catch (error) {
if (error.response && error.response.status === 400) {
  let errorMessage = "Company Group with this name already exists";

  if (error.response.data) {
    try {
      if (typeof error.response.data === 'object') {
        const data = error.response.data;

        if (data.message) {
          errorMessage = data.message;
        } else if (data.error) {
          errorMessage = data.error;
        } else if (Array.isArray(data.errors) && data.errors[0]?.errorMessage) {
          errorMessage = data.errors[0].errorMessage;
        }
      } else if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      }
    } catch (e) {
      console.error("Error parsing API response:", e);
    }
  }

  throw new Error(errorMessage);
}
    throw new Error(error.message || 'Saving carriergroupdetails failed. Please try again.');
  }
};

  export const searchAgency = async(formData, token) => {
    try {
        const response = await apiService('/agency/search', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Seaching agency is failed. Please try again.');
        }
  }

  export const getCarrier = async (token, page, size) => {
    try {
      const headers = {

      };
      const response = await apiService(`/carrier/?page=${page}&size=${size}&sort=asc`, 'GET', null, headers, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

    export const getAllCarrier = async (token, page, size) => {
    try {
      const headers = {
        // 'Access-Control-Request-Headers': '*'
      };
      const response = await apiService(`/carrier/all?page=${page}&size=${size}&sort=asc`, 'GET', null, headers, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const getGroupCarrier = async (token, page, size) => {
    try {
      const headers = {

      };
      const response = await apiService(`/company-group/?page=${page}&size=${size}&sort=desc`, 'GET', null, headers, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const updateCarrier = async (formData, token) => {
    try {

      const response = await apiService('/company-group/', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Updating carrier is failed. Please try again.');
      }
  }


  export const deleteCarrierById = async (Id, token) => {
    try {
      const response = await apiService(`/company-group/${Id}`, 'DELETE', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

    export const getAgencyCodeUserPsw = async (Id, token) => {
    try {
      const response = await apiService(`/company-group/${Id}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const deleteCarrierListingById = async (Id, token) => {
    try {

      const response = await apiService(`/carrier/delete-Carrier/${Id}`, 'DELETE', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const saveProfile = async(formData, token) => {
    try {
      const response = await apiService('/userprofile/save', 'POST', formData, null, token);
      return response;
    } catch (error) {
      if (error.response?.data) {
        throw error.response.data;
      }
      throw {
        errors: [{
          errorMessage: error?.message || 'Saving profile failed. Please try again.',
          target: null
        }]
      };
    }
  };

  export const activeProfileSearch = async(formData, token,page,size) => {
    try {
        const response = await apiService(`/userprofile/search?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving profile is failed. Please try again.');
        }
  }

  export const getProfile = async (token, page, size) => {
    try {
      const headers = {

      };
      const response = await apiService(`/userprofile/all?page=${page}&size=${size}&sort=desc`, 'GET', null, headers, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const deleteUserService = async (token, id) => {
    try {
      const headers = {

      };
      const response = await apiService(`/userprofile/${id}`, 'DELETE', null, headers, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const getUserDetailsService = async (token, id) => {
    try {
      const headers = {

      };
      const response = await apiService(`/userprofile/${id}`, 'GET', null, headers, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const getProfileUser = async (id, token) => {
    try {
      const headers = {

      };
      const response = await apiService('/userprofile/users', 'GET', null, headers, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const updateProfile = async (formData, token) => {
    try {

      const response = await apiService('/userprofile/update', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error || 'Updating profile is failed. Please try again.');
      }
  }

  export const getAllLocations = async (token) => {
    try {
      const response = await apiService(`/addLocation/locations`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'All location service is failed. Please try again.');
    }
  }

  export const searchUserService = async (token, formdata,page,size) => {
    try {
      const response = await apiService(`/userprofile/search?page=${page}&size=${size}`, 'POST', formdata, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

    export const getUserInfoService = async (token) => {
    try {
      const response = await apiService(`/userprofile/info`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

       export const searchManageCarrierListingServices = async (keyword, token, page, size) => {
      try {
          const response = await apiService(`/carrier/search?keyword=${keyword}&page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
          return response;
      } catch (error) {
          console.error('Error fetching filtered data:', error);
      }
    }

   export const searchCompanyGroupServices = async (keyword, carrierName, token, page, size) => {
  try {
    let params = [];

    if (keyword && keyword.trim()) {
      params.push(`keyword=${encodeURIComponent(keyword.trim())}`);
    }

    if (carrierName && carrierName.trim()) {
      params.push(`carrier=${encodeURIComponent(carrierName.trim())}`);
    }

    params.push(`page=${page}`);
    params.push(`size=${size}`);
    params.push(`sort=desc`);

    const queryString = params.join("&");

    const response = await apiService(`/company-group/search?${queryString}`,"GET",null,null,token);

    return response;
  } catch (error) {
    console.error("Error fetching filtered data:", error);
    throw error;
  }
};


  export const searchUserNameService = async (username, token) => {
    try {

      const response = await apiService(`/userprofile/check-username?username=${username}`, 'GET', null, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Search user name is failed. Please try again.');
      }
  }

  export const getCarrierListWithStateServices = async (stateCode, token) => {
    try {
      const response = await apiService(`/carrier/state/${stateCode}`, 'GET', null, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Search user name is failed. Please try again.');
      }
  }

  export const deleteCarrierGroupServices = async (companyGroupId, carrierId, stateCode, token) => {    try {

      const response = await apiService(`/company-group/${companyGroupId}/carriers/${carrierId}/states/${stateCode}`, 'DELETE', null, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Search user name is failed. Please try again.');
      }
  }

export const getCompanyGroups = async (token) => {
  try {
    return await apiService(`/company-group/list`, 'GET', null, null, token)
    // return await apiService(`/company-group/list?query=${encodeURIComponent(searchTerm)}&limit=${limit}`, 'GET', null, null, token);
  } catch (error) {
    throw error?.message || 'Failed to fetch company groups.';
  }
};

export const searchCarrierListService = async (formData, token, page, size) => {
  try {
  const response = await apiService(`/carrier/search?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
  return response;
  } catch (error) {
    throw error?.message || 'Failed to fetch company groups.';
  }
};


export const getUserPermissionService = async (token) => {
  try {
    const response = await apiService(`/permission/assignable`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getUserAllPermissionService = async (id, token) => {
  try {
    const response = await apiService(`/permission/all-permission/${id}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

